import { createApiCallAction } from 'reacticoon/action'

import { getMfaLoggingUserId } from 'modules/auth/config'

//
// Actions
//

export const postLoginMfa = createApiCallAction(
  'App::LoginModule::loginMfa',
  (mfaCode) => ({
    type: 'POST',
    endpoint: '/commands/AUTH_LOGIN_MFA',
    body: {
      command: 'AUTH_LOGIN_MFA',
      payload: {
        mfaLoggingUserId: getMfaLoggingUserId(),
        mfaCode
      },
    },
  })
)
